import walletFinancialPositionsMessages from '../../../../messages/wallet/wallet-financial-positions.messages';
import { Column } from '../../../column';
import { WelfareProduct } from '../../welfare-macro-category';

export const mobileWelfareColumns: Column<WelfareProduct>[] = [
  {
    headerLabel: walletFinancialPositionsMessages.tableHeaderProduct,
    key: 'productName',
    type: 'string',
  },
  {
    headerLabel: walletFinancialPositionsMessages.tableHeaderCounterValueShort,
    key: 'equivalent',
    type: 'amount',
  },
];
